import React from "react";
import { Box, Typography, Grid2 } from "@mui/material";
import LineChartComponent from "./components/LineChart"; // Import LineChart
import BarChartComponent from "./components/BarChart"; // Import BarChart
import PieChartComponent from "./components/PieChart"; // Import PieChart

function TechStaff() {
  // Centralized data for all the charts
  const chartData = {
    lineChartData: [
      { date: "1403/11/8", completedTasks: 85, pendingTasks: 40 },
      { date: "1403/11/9", completedTasks: 90, pendingTasks: 60 },
      { date: "1403/11/10", completedTasks: 80, pendingTasks: 35 },
      { date: "1403/11/11", completedTasks: 75, pendingTasks: 26 },
      { date: "1403/11/12", completedTasks: 65, pendingTasks: 15 },
      { date: "1403/11/13", completedTasks: 70, pendingTasks: 55 },
      { date: "1403/11/14", completedTasks: 80, pendingTasks: 65 },
    ],

    barChartData: [
      { week: "مهدی صانعی", attendanceRate: 24, engagementRate: 65 },
      { week: "احمدرضا رضایی", attendanceRate: 14, engagementRate: 80 },
    ],

    pieChartData: [
      { feedbackType: "سختی 1", value: 10 },
      { feedbackType: "سختی 2", value: 30 },
      { feedbackType: "سختی 3", value: 45 },
      { feedbackType: "سختی 4", value: 15 },
    ],
  };

  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#fff",
        padding: 2,
        direction: "ltr",
      }}
    >
      <Typography variant="h4" sx={{ marginBottom: 4, textAlign: "right" }}>
        بررسی اجمالی گزارش تیم
      </Typography>

      <Grid2 container spacing={2}>
        <Grid2
          size={{ xs: 12, sm: 6 }}
          sx={{
            border: "1px solid #ccc",
            borderRadius: "8px",
          }}
        >
          <Typography variant="h6" sx={{ textAlign: "right", padding: 2 }}>
            : نمودار میزان رضایت بازیکنان و عملرد آن ها
          </Typography>
          <LineChartComponent data={chartData.lineChartData} />
        </Grid2>
        <Grid2
          size={{ xs: 12, sm: 6 }}
          sx={{
            border: "1px solid #ccc",
            borderRadius: "8px",
          }}
        >
          <Typography variant="h6" sx={{ textAlign: "right", padding: 2 }}>
            : بررسی اجمالی گزارش تمرینات مربیان
          </Typography>
          <BarChartComponent data={chartData.barChartData} />
        </Grid2>
        <Grid2
          size={{ xs: 12 }}
          sx={{
            border: "1px solid #ccc",
            borderRadius: "8px",
          }}
        >
          <Typography variant="h6" sx={{ textAlign: "right", padding: 2 }}>
            : میانگین درجه سختی تمرین ها
          </Typography>
          <PieChartComponent data={chartData.pieChartData} />
        </Grid2>
      </Grid2>
    </Box>
  );
}

export default TechStaff;
